/**
 * useAuth — Hook to access auth state from AuthProvider.
 *
 * Must be called within an AuthProvider. Returns the current user,
 * authentication status, and action functions (switchOrg, signOut, refresh).
 *
 * @example
 * ```tsx
 * import { useAuth } from '@plerity/auth/react';
 *
 * function UserMenu() {
 *   const { user, signOut } = useAuth();
 *   if (!user) return null;
 *   return <button onClick={signOut}>{user.name}</button>;
 * }
 * ```
 */

import { useContext } from "react";
import { AuthContext, type AuthContextValue } from "./AuthProvider.js";

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
